export default {
  queryStatusChangeList: '/courier-sqp-api/h5/v1/queryStatusChangeList',
  queryCityImprovementRule: '/courier-sqp-api/h5/v1/queryCityImprovementRule'
}
